<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Amount (Per School)">
            <AmountSelectorList/>
            <br>
            <div class="inhonor__section">
            <InHonorOf />
          </div>
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://www.ou.org/privacy-policy/"/>
            </FormRow>             
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow>
              <Receipt :receipts="['us', 'israel', 'canadian']" />
            </FormRow>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
          <div class="footer-note">
            Contact <a href="mailto:donate@allmishnahjr.org">donate@allmishnahjr.org</a> for more
            information and other dedication opportunities.
          </div>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";
import { ref } from "vue";

export default defineComponent({
  setup() {
    const { setValue, getValue, form } = usePaymentForm();


    return {
      getValue,
      form,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.form-container.ou-donation-form {
  margin: 0px !important;
    padding: 0px !important;
    box-shadow: none !important;
}
::v-deep label {
  line-height: 1.4;
}
::v-deep h2 {
    font-weight: 400;
    margin-bottom: 20px;
    margin-top: 20px;
    font-size: 20px;
    color: #000;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.footer-note {
  text-align: center;
  margin-top: 25px;
  font-size: 14px;
}
.footer__note {
  font-style: italic;
  margin-top: 40px;
  line-height: 1.4;
  text-align: center;
  font-size: 14px;
}
::v-deep textarea {
  padding-top: 5px !important;
  ::-webkit-input-placeholder {
    font-family: inherit;
    line-height: normal;
  }

  :-ms-input-placeholder {
    font-family: inherit;
    line-height: normal;
  }

  :-moz-placeholder {
    font-family: inherit;
    line-height: normal;
  }

  ::-moz-placeholder {
    font-family: inherit;
    line-height: normal;
  }
}
.didcate__note {
  font-size: 13px;
  font-style: italic;
  padding-top: 3px;
  margin-bottom: 8px;
  line-height: normal;
}
::v-deep .joinall{

label{
  display: flex;
  align-items: center;
  gap: 10px;
}
input{
  width: auto;
  margin: 0px;
}

}
::v-deep span.flex > span {
    display: flex;
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container .amount_other__wrapper{
  
      input[type=number]{
      margin-left: 100px !important;
    }

    &:before {
        content: "$";
        position: absolute;
        padding: 15px 8px;
        border-right: 1px solid #ddd;
    }
}

.inhonor__section{
  font-size: 14px;
    margin: 15px 0;
    background-color: #d9edf7;
    color: #31708f;
    padding: 11px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0 solid #000;
}
::v-deep .inhonorof > .form-group:first-child{
  margin-bottom: 0px !important;
  label{
    font-weight: 600;
  }
}
</style>
